module.exports = __webpack_public_path__ + "img/menu-teaser.d6988ab2.jpg";